import React from 'react';
import packageJson from '../../package.json';
import { DynamicIcon } from '../components/icons.jsx';

const AboutSettings = () => {
    const version = packageJson.version;

    return (
        <div className="max-w-4xl mx-auto py-8 px-4 pb-20">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                <div className="bg-blue-600 dark:bg-blue-700 py-1.5 px-6 flex items-center justify-center gap-2 overflow-hidden relative">
                    <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px]"></div>
                    <DynamicIcon name="ShieldCheck" className="w-3.5 h-3.5 text-white animate-pulse" />
                    <span className="text-[10px] font-bold text-white uppercase tracking-[0.2em] relative z-10">
                        Official HIPAA Compliant Environment
                    </span>
                </div>
                <div className="px-6 py-6 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 flex items-center gap-4">
                    <div className="w-16 h-16 bg-purple-100 dark:bg-purple-900/30 rounded-2xl flex items-center justify-center text-purple-600 dark:text-purple-400">
                        <DynamicIcon name="Info" className="w-8 h-8" />
                    </div>
                    <div>
                        <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100">About Platform</h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400">System information and version details.</p>
                    </div>
                </div>
                
                <div className="p-8 space-y-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="space-y-2">
                            <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300">
                                Product Name
                            </label>
                            <p className="text-lg font-medium text-gray-900 dark:text-white">AnnexMed Intelligence Platform</p>
                        </div>
                        
                        <div className="space-y-2">
                            <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300">
                                Current Build Version
                            </label>
                            <div className="flex items-center gap-3">
                                <span className="px-3 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-full text-sm font-bold border border-green-200 dark:border-green-800">
                                    v{version}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="pt-6 border-t border-gray-100 dark:border-gray-700">
                        <h4 className="text-md font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                            <DynamicIcon name="Cpu" className="w-4 h-4 text-purple-500" />
                            Platform Information
                        </h4>
                        
                        <div className="bg-gray-50 dark:bg-gray-900/30 p-6 rounded-xl border border-gray-100 dark:border-gray-800">
                            <div className="prose dark:prose-invert max-w-none">
                                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                                    The AnnexMed Intelligence Platform is a comprehensive data and AI orchestration suite designed for healthcare and enterprise environments. This build contains the latest performance optimizations and security patches.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4">
                        <div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800">
                            <div className="flex items-center gap-2 mb-1">
                                <DynamicIcon name="Globe" className="w-3.5 h-3.5 text-blue-500" />
                                <p className="text-xs text-blue-700 dark:text-blue-300 uppercase tracking-wider font-bold">Data Region</p>
                            </div>
                            <p className="text-sm font-medium dark:text-gray-200">United States (USA)</p>
                        </div>
                        
                        <div className="p-4 bg-teal-50 dark:bg-teal-900/20 rounded-lg border border-teal-100 dark:border-teal-800">
                            <div className="flex items-center gap-2 mb-1">
                                <DynamicIcon name="ShieldCheck" className="w-3.5 h-3.5 text-teal-500" />
                                <p className="text-xs text-teal-700 dark:text-teal-300 uppercase tracking-wider font-bold">PHI Masking</p>
                            </div>
                            <p className="text-sm font-medium dark:text-gray-200">Enabled (Always-On)</p>
                        </div>

                        <div className="p-4 bg-indigo-50 dark:bg-indigo-900/20 rounded-lg border border-indigo-100 dark:border-indigo-800">
                            <div className="flex items-center gap-2 mb-1">
                                <DynamicIcon name="Lock" className="w-3.5 h-3.5 text-indigo-500" />
                                <p className="text-xs text-indigo-700 dark:text-indigo-300 uppercase tracking-wider font-bold">Compliance</p>
                            </div>
                            <p className="text-sm font-medium dark:text-gray-200">HIPAA Compliant Environment</p>
                        </div>
                    </div>
                </div>
                
                <div className="px-8 py-4 bg-gray-50 dark:bg-gray-900/50 border-t border-gray-200 dark:border-gray-700 text-center">
                    <p className="text-xs text-gray-400">© 2026 AnnexMed Intelligence Platform. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default AboutSettings;
